export class RefCampagne {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        annee: { key: 'annee' }
    };

    public id: number = undefined;
    public code: string = undefined;
    public annee: number = undefined;
}
